import Repository from '../axios'

const resource = "/landlord/go_cardless"

export default {
  createBillingRequest (payload) {
    return Repository.post(`${resource}/billing_requests`,payload)
  },
  createBillingRequestFlow (payload) {
    return Repository.post(`${resource}/billing_request_flow/create`,payload)
  }
}
